/**
 * What a composer does with a transcript that just came back.
 *
 * A recording is dictated INTO whatever is already in the box — the user may
 * have typed half a sentence before reaching for the microphone — so the
 * transcript is appended rather than assigned, and the separating space is only
 * added when there is something to separate it from.
 */ export function appendTranscriptToDraft(draft, transcript) {
    return draft ? `${draft} ${transcript}` : transcript;
}
/**
 * Puts the caret back behind the dictated text, on the frame AFTER the layout
 * has swapped the recording bar back for the textarea — the element does not
 * exist yet when the transcript arrives, which is why this takes the ref and
 * not the element.
 */ export function focusDraftEnd(textareaRef) {
    requestAnimationFrame(()=>{
        const textarea = textareaRef.current;
        if (!textarea) return;
        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
    });
}

//# sourceMappingURL=voice-draft.js.map